import Logger, { ErrorType, LoggerImplementation } from "@ane/core/lib/services/logging/Logger";
import { ApplyOnClickInterceptor } from "@ane/core/lib/services/logging/ReactInterceptors";
import { applyRestLoggerMiddleware } from "@ane/core/lib/services/logging/RestLogger";
import { PopupLogProvider } from "@ane/core/lib/services/logging/PopupLogProvider";
import NotificationService from "@ane/core/lib/services/NotificationService";
import { ErrorDisplay } from "@ane/legacy/lib/components/ErrorDisplay";
import { ApplicationInsightsLogProvider } from "@ane/core/lib/services/logging/ApplicationInsightsLogProvider";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import * as _ from "lodash";
const LoggingBootstrapper = () => {
  ApplyOnClickInterceptor();
  applyRestLoggerMiddleware();
  window.onerror = (message, url = "", lineNo = null, columnNo = null, error = { stack: "", name: "unknown", message: "" }) => {
    const isKnown = checkKnownError(message, url, lineNo, columnNo, error);
    const { stack = "" } = error || {};
    if (!!isKnown) {
      Logger.log(message && message.toString(), { url, lineNo, columnNo, error: JSON.stringify(error), errorStack: stack });
    } else {
      Logger.error(error, ErrorType.BootstrapperUnknown, {
        url,
        lineNo,
        columnNo,
        error: JSON.stringify(error),
        errorStack: stack
      });
    }
  };
  window.addEventListener("unhandledrejection", (event) => {
    const { reason } = event;
    let message = "";
    let stack = "";
    if (typeof reason == "object") {
      message = reason.message;
      stack = reason.stack || "";
    } else {
      message = reason;
    }
    if (!message) {
      Logger.log("unhandledrejection", {
        error: event,
        stack
      });
      return;
    }
    let checkMessage = "";
    let errorCorrelationId = null;
    let thrownFrom = null;
    if (typeof reason == "object") {
      const { message: errorMessage = "", stack: checkStack = "" } = reason;
      checkMessage += `${errorMessage}${checkStack}`;
      errorCorrelationId = reason.errorCorrelationId;
      reason.thrownFrom = thrownFrom;
    } else {
      checkMessage = reason;
    }
    if (!checkKnownError(checkMessage)) {
      Logger.error(reason, ErrorType.BootstrapperListenerUnknown, {
        error: reason,
        stack,
        errorCorrelationId,
        thrownFrom
      });
    } else {
      Logger.log(message, {
        error: reason,
        stack
      });
    }
  });
  NotificationService.setComponent(ErrorDisplay);
  let logProviders = [new PopupLogProvider(NotificationService)];
  if (!EnvironmentService.isTest) {
    const loggerInstance = Logger;
    logProviders = logProviders.concat([
      // we pass in the access method for pageViewDataProvider to allow TelemetryInitializer
      // to log pageView specific information (with each logging call)
      new ApplicationInsightsLogProvider(null, loggerInstance.standardLoggingPropertiesProvider.bind(loggerInstance))
    ]);
  }
  LoggerImplementation.setEqualityMethod(_.isEqual);
  LoggerImplementation.initialize(logProviders);
};
const checkKnownError = (message, url = "", lineNo = null, columnNo = null, error) => {
  const { stack = "" } = error || {};
  let output = stack;
  if (typeof message === "object") {
    const { stack: errorStack = "", message: errorMessage = "" } = message;
    output += `${errorStack}${errorMessage}`;
  }
  if (typeof message === "string") {
    output += `${message}`;
  }
  let isKnown = false;
  if (/Illegal value for lineNumber/.test(output) && /getLineFirstNonWhitespaceColumn/.test(output)) {
    isKnown = true;
  }
  if (/Unexpected usage/.test(output) && /loadForeignModule/.test(output)) {
    isKnown = true;
  }
  if (/ResizeObserver loop limit exceeded/i.test(output)) {
    isKnown = true;
  }
  if (/Object.getExtensionURL/.test(output) || /Extension context invalidated/.test(output)) {
    isKnown = true;
  }
  if (/Uncaught/.test(output) && /worker.js/i.test(url)) {
    isKnown = true;
  }
  if (/Script error./.test(output) || /splitLinesCollection.ts/.test(output)) {
    isKnown = true;
  }
  return isKnown;
};
export {
  LoggingBootstrapper,
  LoggingBootstrapper as default
};
//# sourceMappingURL=LoggingBootstrapper.js.map
